<template>
	<div class="breadrumb-index">
		<div class="breadrumb-index-left" v-if="rightShow">
			<div>您现在位置：</div>
			<ul class="bread-ul">
				<li v-for="(item, index) in list" :key="index" @click="goLi(item)">
					<span class="bread-li-name" :class="{'bread-li-active': index === list.length - 1}">{{item.name}}</span>
					<span class="bread-li-name" v-if="index !== list.length - 1">></span>
				</li>
			</ul>
		</div>
		<div class="right-bont" v-if="rightShow" @click="goBack">{{ top_url_name }}</div>
		<span v-else>
			您现在位置：
			<span class="right-show-span" v-for="(item, index) in list" :key="index" @click="goLi(item)">
				<span class="bread-li-name" :class="{'bread-li-active': index === list.length - 1}">{{item.name}}</span>
				<span class="bread-li-name" v-if="index !== list.length - 1">></span>
			</span>
		</span>
	</div>
</template>

<script>
	export default {
	  props: {
	    list: {
	      type: Array
		},
		rightShow: {
	      type: Boolean,
		  default: false
		},
      top_url: {
        type: String,
        default: null,
      },
      top_url_name: {
        type: String,
        default: '返回首页'
      }
	  },
		data() {
			return {
			}
		},
		methods: {
          goLi (i) {
            if (i.url !== '') {
              this.$router.push(i.url)
			}
		  },
      goBack () {
            if(!!this.top_url){
              window.location.href= this.top_url
            } else {
              let activityView = sessionStorage.getItem('activityView')
              if (!activityView) {
                this.$router.push(this.list[0].url)
              } else {
                activityView = JSON.parse(activityView)
                this.$router.push('../?id=' + activityView.id)
              }
            }
		  }
		}
	}
</script>

<style lang="scss" scoped>
	.breadrumb-index{
		display: flex;
		justify-content: space-between;
		font-size: 13px;
		color: #bbb;
		.breadrumb-index-left{
			display: flex;
			width: 76%;
			margin-top: 4px;

		}
	}
.bread-ul{
	display: flex;
	li{
		max-width: 80%;
	}
	.bread-li-name{
		margin: 0 2px;
	}
	.bread-li-active{
		color: #0034e8;
		font-weight: bold;
	}
	li:nth-of-type(1) .bread-li-name{
		margin-left: 0;
	}
}
.right-show-span{
	.bread-li-name{
		margin: 0 2px;
	}
	span:nth-of-type(1) .bread-li-name{
		margin-left: 0;
	}
	.bread-li-active{
		color: #0034e8;
		font-weight: bold;
	}
}
	.right-bont{
    padding: 0 10px;
    min-width: 64px;
		height: 26px;
		line-height: 26px;
		border-radius: 4px;
		background-color: #0034e8;
		color: #ffffff;
		text-align: center;
    box-sizing: border-box;
	}
</style>



// WEBPACK FOOTER //
// src/components/public/breadcrumb.vue